<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="msgSemResultado">
    Não foram encontradas máscaras com os filtros informados.
  </div>

  <div *ngIf="cnaesPermitidos && cnaesPermitidos.length">
      <div class="d-flex justify-content-end">
          <button [disabled]="cnaesPermitidos.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarCnaes()"
          placement="top" ngbTooltip="Exporta todos os CNAE's listados">
          <i class="fa fa-file"></i> Exportar CNAE's</button>
      </div>
      <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
      <bn-paginacao
          [total]="atributosPaginacao.count"
          [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
          [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
          <div class="table-responsive">
              <table class="table table-hover">
                  <thead>
                      <tr class="text-center">
                          <th id="mascara" scope="col">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'mascara'"
                                  [nomeAtributoExibicao]="'Máscara'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="tipoOperacao" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'tipoOperacao'"
                                  [nomeAtributoExibicao]="'Tipo da Operação'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="objetivoFinanciamento" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'objetivoFinanciamento'"
                                  [nomeAtributoExibicao]="'Objetivo do Financiamento'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="dataInicioValidade" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataInicioValidade'"
                                  [nomeAtributoExibicao]="'Início da validade de permissão'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="dataFimValidade" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataFimValidade'"
                                  [nomeAtributoExibicao]="'Fim da validade de permissão'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="justificativaEncerramento" scope="col" class="text-end">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'justificativaEncerramento'"
                                  [nomeAtributoExibicao]="'Justificativa término da validade'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-end">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="''"
                                  [nomeAtributoExibicao]="' '">
                              </bn-ordenacao>
                          </th>

                      </tr>
                  </thead>

                  <tbody>
                      <ng-container *ngFor="let mascara of cnaesPermitidos; let i = index">
                          <tr (mouseenter)="hover(i)"
                            (mouseleave)="hoverClean()">
                              <td>{{ mascara.mascara?.toUpperCase() }}</td>
                              <td class="text-center">{{ mascara.tipoOperacao }}</td>
                              <td class="text-center">{{ mascara.objetivoFinanciamento }}</td>
                              <td class="text-center">{{ mascara.dataInicioValidade | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-center">{{ mascara.dataFimValidade | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-center">{{ mascara.justificativaEncerramento }}</td>
                              <td>
                                <a href="javascript:void(0)" *ngIf="podeCadastrarEncerrar" (click)="encerrarVigencia(mascara.id)">
                                    <i *ngIf="rowHovered === i && !mascara.dataFimValidade"
                                        class="fa fa-ban cursor-pointer text-danger ms-3"
                                        placement="left-top"
                                        ngbTooltip="Encerra a vigência do CNAE">
                                    </i>
                                </a>
                              </td>
                          </tr>
                      </ng-container>
                  </tbody>

              </table>
          </div>
      </bn-paginacao>
  </div>
</div>

<ng-template #body>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
          <div class="bn-form-group col-md-4">
            <label><b>Máscara</b></label>
            <input class="form-control" id="mascara" value="{{ cnaeDesativando.mascara }}" maxlength="8" disabled/>
          </div>

          <div class="bn-form-group col-md-4">
            <label><b>Fim da validade de impedimento</b></label>
            <input class="form-control" id="dataInicioValidadeImpedimento" value="{{ tomorrow }}" disabled/>
          </div>

          <div class="bn-form-group col-md-12">
            <label><b>Justificativa do fim da validade de permissão: </b></label>
            <textarea class="form-control" id="justificativa" [(ngModel)]="justificativa" required maxlength="500"></textarea>
          </div>
      </div>

      <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
      </div>

    </div>
  </ng-template>

  <ng-template #botoes>
    <button class="btn btn-danger" (click)="close()">Fechar</button>
    <button class="btn btn-success" (click)="salvar()">Salvar</button>
  </ng-template>
